export default __webpack_public_path__ + "assets/images/6223df86bf8662a1f5648b56bf1843ae.png";